// src/features/meetings/MeetingPage.js
import Layout from '../../components/Layout';
import MeetingForm from './MeetingForm';

export default function MeetingPage() {
  return (
    <Layout variant="calculator">
      <MeetingForm />
    </Layout>
  );
}
